import { NgModule } from '@angular/core';
import { ModalConfirmComponent } from './modal-confirm.component';
import { ModalConfirmService } from './modal-confirm.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PhdSoftWindowModule } from '@phdsoft/window';
@NgModule({
  declarations: [ModalConfirmComponent],
  imports: [
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    DragDropModule,
    PhdSoftWindowModule
  ],
  providers: [ModalConfirmService],
  exports: [ModalConfirmComponent,]
})
export class ModalConfirmModule { }
